export const hustlingConstants = {
    RESET: 'RESET',
    HUSTLING_FETCHING: 'HUSTLING_FETCHING',
    HUSTLING_FETCHED: 'HUSTLING_FETCHED',
    HUSTLING_SUBMITTING: 'HUSTLING_SUBMITTING',
    HUSTLING_SUBMITTED: 'HUSTLING_SUBMITTED',
    LOAD_HUSTLING: 'LOAD_HUSTLING',
    GET_HUSTLING_BY_CODE: 'GET_HUSTLING_BY_CODE',
    VOYAGE_HUSTLING_LIST: 'VOYAGE_HUSTLING_LIST',
    LOAD_VOYAGE_HUSTLING: 'LOAD_VOYAGE_HUSTLING',
}